/**
 * Project image URL map. Migrated from Vite `import.meta.glob('?url')` to static
 * /public path strings — call sites (`projectImages['noxiy.webp']`) are unchanged.
 */
export const projectImages: Record<string, string> = {
  'a-sic.webp': '/projects/a-sic.webp',
  'amir-shetaia.webp': '/projects/amir-shetaia.webp',
  'byond-media.webp': '/projects/byond-media.webp',
  'eye-of-horus.webp': '/projects/eye-of-horus.webp',
  'houzit.webp': '/projects/houzit.webp',
  'loop-dimension.webp': '/projects/loop-dimension.webp',
  'ludus.webp': '/projects/ludus.webp',
  'lunexa-ioe.webp': '/projects/lunexa-ioe.webp',
  'makersgate.webp': '/projects/makersgate.webp',
  'noxiy.webp': '/projects/noxiy.webp',
  'opsera.webp': '/projects/opsera.webp',
  'project-02.webp': '/projects/project-02.webp',
  'unlimited-eg.webp': '/projects/unlimited-eg.webp',
}
